/**
 * Parse a date string (YYYY-MM-DD) or Firestore timestamp as a local date
 * This ensures dates are not shifted due to timezone conversions
 */
export const parseDateLocal = (dateValue) => {
  if (!dateValue) return null;

  // If it's a Firestore timestamp
  if (dateValue.toDate) {
    const jsDate = dateValue.toDate();
    // Extract the local date components and create a new date at midnight local time
    return new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate());
  }

  // If it's already a Date object
  if (dateValue instanceof Date) {
    return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
  }

  // If it's a string in YYYY-MM-DD format
  if (typeof dateValue === 'string') {
    const [year, month, day] = dateValue.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  return null;
};

/**
 * Get a date string in YYYY-MM-DD format from a Date object
 */
export const formatDateLocal = (date) => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Compare two dates (ignoring time) to see if they're the same day
 */
export const isSameDay = (date1, date2) => {
  if (!date1 || !date2) return false;
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};
